import React from "react";
import { InsTreeMapChart } from "../insTreeMapChart";
import { InsDonutChart, InsRangeChart, InsQuartileRanking, InsTimeSeriesChart, InsScatterPlotDatapointChart, InsHorizontalDatapointStackedBarChart, InsHorizontalBarDatapointChart, InsRadarChart, InsWaterfallDatapointChart, InsWaterfallComparisonChart, InsHorizontalBarComparisonChart, InsStackedColumnChart, InsHeatMap, InsBubbleChart } from "components";
import { useWidgetComponentProps, useWidgetCurrentChartType } from "components/widgets/hooks/use-current-widget";
export const InsChartFactory = (props) => {
    const { sectionId, widgetId } = props;
    const currentChartType = useWidgetCurrentChartType(sectionId, widgetId);
    const widgetProps = useWidgetComponentProps(sectionId, widgetId);
    const chartType = currentChartType || widgetProps?.chartType;
    switch (chartType) {
        case "InsDonutChart":
            return React.createElement(InsDonutChart, { ...props });
        case "InsTreeMapChart":
            return React.createElement(InsTreeMapChart, { ...props });
        case "InsHorizontalDatapointStackedBarChart":
            return React.createElement(InsHorizontalDatapointStackedBarChart, { ...props });
        case "insHorizontalBarDatapointChart":
            return React.createElement(InsHorizontalBarDatapointChart, { ...props });
        case "insHorizontalBarComparisonChart":
            return React.createElement(InsHorizontalBarComparisonChart, { ...props });
        case "InsScatterPlotDatapointChart":
            return React.createElement(InsScatterPlotDatapointChart, { ...props });
        case "InsRangeChart":
            return React.createElement(InsRangeChart, { ...props });
        case "InsRadarChart":
            return React.createElement(InsRadarChart, { ...props });
        case "InsQuartileRanking":
            return React.createElement(InsQuartileRanking, { ...props });
        case "InsWaterfallDatapointChart":
            return React.createElement(InsWaterfallDatapointChart, { ...props });
        case "InsTimeSeriesChart":
            return React.createElement(InsTimeSeriesChart, { ...props });
        case "InsWaterfallComparisonChart":
            return React.createElement(InsWaterfallComparisonChart, { ...props });
        case "InsStackedColumnChart":
            return React.createElement(InsStackedColumnChart, { ...props });
        case "InsHeatMap":
            return React.createElement(InsHeatMap, { ...props });
        case "InsBubbleChart":
            return React.createElement(InsBubbleChart, { ...props });
        default:
            return React.createElement(React.Fragment, null, "In Construction");
    }
};
